export default __webpack_public_path__ + "static/media/VE.2f407014.svg";